import React from 'react';

const Spinner = () => {
    return (
        <div className="rte-spinner-container">
            <div className="rte-spinner"></div>
        </div>
    );
};

export default Spinner;
